import { render } from "./LootCrateModal.vue?vue&type=template&id=8e32ff88"
import script from "./LootCrateModal.vue?vue&type=script&lang=js"
export * from "./LootCrateModal.vue?vue&type=script&lang=js"

import "./LootCrateModal.vue?vue&type=style&index=0&id=8e32ff88&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__